import { ReactNode, useLayoutEffect, useRef } from "react";

interface TcTechnicalSummaryCaptureProps {
  children: ReactNode;
}

interface TcTechnicalSummaryRenderWindow extends Window {
  reportHtmlCapture?: string;
}

export function TcTechnicalSummaryCapture({
  children,
}: TcTechnicalSummaryCaptureProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const documentElement = containerRef.current?.firstElementChild;
    if (!documentElement) return undefined;
    const renderWindow = window as TcTechnicalSummaryRenderWindow;
    renderWindow.reportHtmlCapture = buildSelfContainedHtml(documentElement);
    documentElement.setAttribute("data-tc-summary-render-complete", "true");
    return () => {
      delete renderWindow.reportHtmlCapture;
    };
  }, []);

  return (
    <div ref={containerRef} style={{ display: "contents" }}>
      {children}
    </div>
  );
}

function buildSelfContainedHtml(documentElement: Element): string {
  const css = Array.from(document.styleSheets)
    .flatMap((sheet) => {
      try {
        return Array.from(sheet.cssRules).map((rule) => rule.cssText);
      } catch {
        return [];
      }
    })
    .join("\n");
  return [
    "<!doctype html><html><head>",
    '<meta charset="utf-8">',
    `<style>${css}\n@page { size: letter portrait; margin: 0; }</style>`,
    "</head><body>",
    documentElement.outerHTML,
    "</body></html>",
  ].join("");
}
